"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Timer {
    constructor(interval = 100, callback = null) {
        this.interval = interval;
        this.elapsed = 0;
        this.callback = callback;
        this.active = false;
    }
    get window() {
        return window;
    }
    get Elapsed() {
        return this.elapsed;
    }
    start() {
        if (!this.active) {
            this.timer = this.window.setInterval(this.increment.bind(this), this.interval);
            this.active = true;
        }
    }
    pause() {
        this.window.clearInterval(this.timer);
        this.active = false;
    }
    reset() {
        this.elapsed = 0;
    }
    increment() {
        this.elapsed += this.interval;
        if (this.callback)
            this.callback();
    }
}
exports.Timer = Timer;
